import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

// Keyframes for spinner animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Styled components
const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #000; /* Background color */
  color: #fff; /* Text color */
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #fff;
  border-top: 5px solid #000;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 20px;
`;

const Percentage = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-top: 10px;
`;

const Loading = ({ onLoadingComplete }) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercentage((prev) => {
        if (prev < 100) return prev + 1;
        clearInterval(interval);
        onLoadingComplete(); // Call callback when loading reaches 100%
        return prev;
      });
    }, 30); // Adjust speed as needed (30ms for smoother loading)

    return () => clearInterval(interval);
  }, [onLoadingComplete]);

  return (
    <LoadingWrapper>
      <Spinner />
      <Percentage>Marcha World Loading: {percentage}%</Percentage>
      
    </LoadingWrapper>
  );
};

export default Loading;
